/* Collection toolbar: grid/list view switch (persisted) and a small product compare tray (max 3, persisted). */
(function () {
  var VIEW_KEY = 'jb-collection-view';
  var CMP_KEY = 'jb-compare-items';
  var MAX = 3;
  var root = document.documentElement;

  function read(key, fallback) {
    try { var v = JSON.parse(localStorage.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
  }

  /* ---------- grid / list ---------- */
  function applyView(view) {
    root.classList.toggle('jb-view-list', view === 'list');
    document.querySelectorAll('[data-jb-view]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-jb-view') === view ? 'true' : 'false');
    });
  }
  applyView(read(VIEW_KEY, 'grid'));

  /* ---------- filter sidebar toggle ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jb-filter-toggle]');
    if (!btn) return;
    var hidden = root.classList.toggle('jb-filters-hidden');
    btn.setAttribute('aria-expanded', hidden ? 'false' : 'true');
  });

  /* ---------- compare ---------- */
  var items = read(CMP_KEY, []);
  var compareOn = false; /* always off on a fresh page load; the toggle only lasts for this page view */
  var notice = null;
  var bar = null;
  var modal = null;
  var i18n = null;

  function strings() {
    if (i18n) return i18n;
    var toggle = document.querySelector('[data-jb-i18n]');
    try { i18n = JSON.parse(toggle.getAttribute('data-jb-i18n')); } catch (e) { i18n = {}; }
    return i18n;
  }

  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    if (text != null) node.textContent = text;
    return node;
  }

  function money(cents) {
    var code = window.Shopify && Shopify.currency && Shopify.currency.active;
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: code || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function syncToggle() {
    root.classList.toggle('jb-compare-on', compareOn);
    document.querySelectorAll('[data-jb-compare-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-checked', compareOn ? 'true' : 'false');
    });
  }

  function syncChecks() {
    var handles = items.map(function (i) { return i.handle; });
    document.querySelectorAll('[data-jb-compare]').forEach(function (box) {
      box.checked = handles.indexOf(box.getAttribute('data-handle')) > -1;
    });
  }

  function closeModal() {
    if (modal) modal.hidden = true;
  }

  function renderBar(withLimit) {
    var show = compareOn;
    if (!show) {
      if (bar) bar.hidden = true;
      document.body.classList.remove('jb-has-compare-bar');
      return;
    }
    var t = strings();
    if (!bar) {
      bar = el('div', { 'class': 'jb-compare-bar', role: 'region' });
      document.body.appendChild(bar);
    }
    bar.hidden = false;
    document.body.classList.add('jb-has-compare-bar');
    bar.textContent = '';
    bar.setAttribute('aria-label', (t.title || 'Compare').replace('%s', items.length));
    var inner = el('div', { 'class': 'jb-compare-bar__inner page-width' });
    inner.appendChild(el('span', { 'class': 'jb-compare-bar__title' }, (t.title || 'Compare (%s/3)').replace('%s', items.length)));
    var list = el('ul', { 'class': 'jb-compare-bar__items' });
    items.forEach(function (item) {
      var li = el('li');
      if (item.image) li.appendChild(el('img', { src: item.image, alt: item.title }));
      var rm = el('button', { type: 'button', 'aria-label': (t.remove || 'Remove') + ' ' + item.title, 'data-jb-compare-remove': item.handle }, '×');
      li.appendChild(rm);
      list.appendChild(li);
    });
    inner.appendChild(list);
    if (withLimit) inner.appendChild(el('span', { 'class': 'jb-compare-bar__notice', role: 'alert' }, t.limit || 'You can compare up to 3 products.'));
    inner.appendChild(el('button', { type: 'button', 'class': 'jb-compare-bar__clear', 'data-jb-compare-clear': '' }, t.clear || 'Clear all'));
    var go = el('button', { type: 'button', 'class': 'jb-compare-bar__btn', 'data-jb-compare-open': '' }, t.button || 'Compare now');
    if (items.length < 2) go.disabled = true;
    inner.appendChild(go);
    bar.appendChild(inner);
  }

  function showLimit() {
    renderBar(true);
    var msg = bar && bar.querySelector('.jb-compare-bar__notice');
    if (!msg) return;
    clearTimeout(notice);
    notice = setTimeout(function () { msg.remove(); }, 4000);
  }

  function setItems(next) {
    items = next;
    write(CMP_KEY, items);
    syncChecks();
    renderBar();
  }

  function openModal() {
    var t = strings();
    if (!modal) {
      modal = el('div', { 'class': 'jb-compare-modal', role: 'dialog', 'aria-modal': 'true' });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.textContent = '';
    var box = el('div', { 'class': 'jb-compare-modal__box' });
    var close = el('button', { type: 'button', 'class': 'jb-compare-modal__close', 'aria-label': t.close || 'Close' }, '×');
    close.addEventListener('click', closeModal);
    box.appendChild(close);
    var status = el('p', { role: 'status' }, '…');
    box.appendChild(status);
    modal.appendChild(box);
    close.focus();

    Promise.all(items.map(function (item) {
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      status.remove();
      var table = el('table', { 'class': 'jb-compare-table' });
      function row(label, fill) {
        var tr = el('tr');
        tr.appendChild(el('th', { scope: 'row' }, label));
        products.forEach(function (p) { var td = el('td'); fill(td, p); tr.appendChild(td); });
        table.appendChild(tr);
      }
      row('', function (td, p) {
        var src = p.featured_image || (p.images && p.images[0]) || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (src) td.appendChild(el('img', { src: src.replace(/(\.[a-z]+)(\?|$)/i, '_360x$1$2'), alt: p.title }));
        var a = el('a', { href: p.url }, p.title);
        td.appendChild(el('p')).appendChild(a);
      });
      row(t.price || 'Price', function (td, p) {
        td.textContent = money(p.price);
        if (p.compare_at_price > p.price) {
          var s = el('s', {}, ' ' + money(p.compare_at_price));
          td.appendChild(s);
        }
      });
      row(t.vendor || 'Brand', function (td, p) { td.textContent = p.vendor || '—'; });
      row(t.type || 'Type', function (td, p) { td.textContent = p.type || '—'; });
      row(t.availability || 'Availability', function (td, p) { td.textContent = p.available ? (t.inStock || 'In stock') : (t.outOfStock || 'Sold out'); });
      row(t.about || 'About', function (td, p) {
        var tmp = document.createElement('div');
        tmp.innerHTML = p.description || '';
        var text = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        td.textContent = text.length > 220 ? text.slice(0, 217) + '…' : text;
      });
      box.appendChild(table);
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest ? e.target.closest('button') : null;
    if (!target) return;
    if (target.hasAttribute('data-jb-view')) {
      var view = target.getAttribute('data-jb-view');
      write(VIEW_KEY, view);
      applyView(view);
    } else if (target.hasAttribute('data-jb-compare-toggle')) {
      compareOn = !compareOn;
      syncToggle();
      renderBar();
    } else if (target.hasAttribute('data-jb-compare-remove')) {
      var handle = target.getAttribute('data-jb-compare-remove');
      setItems(items.filter(function (i) { return i.handle !== handle; }));
    } else if (target.hasAttribute('data-jb-compare-clear')) {
      setItems([]);
    } else if (target.hasAttribute('data-jb-compare-open')) {
      openModal();
    }
  });

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.matches || !box.matches('[data-jb-compare]')) return;
    var handle = box.getAttribute('data-handle');
    if (box.checked) {
      if (items.length >= MAX) {
        box.checked = false;
        showLimit();
        return;
      }
      setItems(items.concat([{ handle: handle, title: box.getAttribute('data-title'), url: box.getAttribute('data-url'), image: box.getAttribute('data-image') }]));
    } else {
      setItems(items.filter(function (i) { return i.handle !== handle; }));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function init() {
    applyView(read(VIEW_KEY, 'grid'));
    syncToggle();
    syncChecks();
    renderBar();
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(function () { syncChecks(); }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Collection card hover "Add to cart": Dawn-style /cart/add.js with sections, then render the drawer (or notification). */
(function () {
  function showError(form, message) {
    var box = form.querySelector('.jb-card-quick-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'jb-card-quick-error caption';
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message || '';
    box.hidden = !message;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('.product-card-wrapper .quick-add')) return;
    var holder = form.closest('product-form');
    if (!holder) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var button = form.querySelector('[type="submit"]');
    if (button.getAttribute('aria-disabled') === 'true') return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var spinner = form.querySelector('.loading__spinner');

    showError(form, '');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var body = new FormData(form);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = body;
    var variantId = body.get('id');

    fetch(routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          showError(form, response.description || response.message);
          return;
        }
        if (!cart) { window.location = routes.cart_url; return; }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jb-card-quick-add', productVariantId: variantId, cartData: response });
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function (err) {
        console.error(err);
        showError(form, err && err.message ? err.message : 'Network error');
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
})();
